import { addDays, differenceInCalendarDays, format, isValid, parseISO } from 'date-fns'
import type { Deal } from '@/types'

export const TESTE_GRATIS_DAYS = 30

export type TesteGratisTiming = {
  enteredLabel: string
  remainingCaption: string
  remainingLabel: string
  overdue: boolean
}

function parseDate(value?: string) {
  if (!value) return null
  const date = parseISO(value)
  return isValid(date) ? date : null
}

export function getTesteGratisTiming(deal: Pick<Deal, 'etapa' | 'testeGratisDesde'>, now = new Date()): TesteGratisTiming | null {
  if (deal.etapa !== 'teste_gratis') return null
  const entered = parseDate(deal.testeGratisDesde)
  if (!entered) return null

  const due = addDays(entered, TESTE_GRATIS_DAYS)
  const daysLeft = differenceInCalendarDays(due, now)
  const late = Math.abs(daysLeft)

  let remainingCaption = 'Falta'
  let remainingLabel = 'hoje'
  if (daysLeft === 1) remainingLabel = '1 dia'
  else if (daysLeft > 1) remainingLabel = `${daysLeft} dias`
  else if (daysLeft < 0) {
    remainingCaption = 'Atraso'
    remainingLabel = late === 1 ? '1 dia' : `${late} dias`
  }

  return {
    enteredLabel: format(entered, 'dd/MM/yyyy'),
    remainingCaption,
    remainingLabel,
    overdue: daysLeft < 0,
  }
}
